<!-- src/lib/components/ui/MonthYearSwitch.svelte -->
<script lang="ts">
	import { Switch as SwitchPrimitive } from 'bits-ui';
	import { cn } from '$lib/utils';

	type $$Props = SwitchPrimitive.Props & {
		class?: string;
	};

	export let checked: boolean;
	export let className: $$Props['class'] = undefined;
	export { className as class };
</script>

<div class="flex items-center justify-center gap-8 text-xl font-normal">
	<span class={cn(!checked && 'opacity-100', checked && 'opacity-60')}> YEARLY </span>
	<SwitchPrimitive.Root
		bind:checked
		class={cn(
			'relative inline-flex h-[46px] w-[200px] shrink-0 cursor-pointer items-center rounded-full border-2 border-gold bg-black transition-colors focus-visible:outline-none focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50',
			className
		)}
		{...$$restProps}
		on:click
		on:keydown
	>
		<SwitchPrimitive.Thumb
			class={cn(
				'pointer-events-none block h-[38px] w-[90px] rounded-full bg-[#9CA3AF] transition-transform duration-200',
				'data-[state=checked]:translate-x-[102px] data-[state=unchecked]:translate-x-[4px]'
			)}
		/>
	</SwitchPrimitive.Root>
	<span class={cn(checked && 'opacity-100', !checked && 'opacity-60')}> MONTHLY </span>
</div>
